import { ActionsHook } from "@/lib/Components/Actions/ActionGroupButtons";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { deleteRelocationPageMutation } from "@/app/Settings/Admin/RelocationPages/queries/relocationPageMutations";
import {
  ArrowTopRightOnSquareIcon,
  PencilIcon,
} from "@heroicons/react/20/solid";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { UpdateRelocationPageDialog } from "@/app/Settings/Admin/RelocationPages/Components/UpdateRelocationPageDialog";
import { RelocationPageListItem } from "@/app/Settings/Admin/RelocationPages/GraphQL/relocationPageListQuery";

export function useRelocationPageActions(): ActionsHook<RelocationPageListItem> {
  const { mutateAsync } = useGqlMutation(deleteRelocationPageMutation);
  const { open } = useDialog(UpdateRelocationPageDialog);
  return (model) => {
    return [
      {
        label: "Actions",
        items: [
          {
            actions: [
              {
                label: "View",
                Icon: ArrowTopRightOnSquareIcon,
                handleAction: () => {
                  window.open(
                    new URL(
                      `/routes/${model.slug}`,
                      import.meta.env.VITE_APP_URL,
                    ),
                    "_blank",
                  );
                },
              },
            ],
          },
          {
            actions: [
              {
                label: "Update",
                Icon: PencilIcon,
                handleAction: () => {
                  open({
                    relocationPageSlug: model.slug,
                  });
                },
              },
            ],
          },
          {
            actions: [
              {
                label: "Delete",
                color: "red",
                handleAction: async () => {
                  await mutateAsync({
                    id: model.id,
                  });
                },
              },
            ],
          },
        ],
      },
    ];
  };
}
